import React from 'react';

const NotFound = () => {
  return (
    <div className='text-center'>
      <h2>404 - Page Not Found</h2>
      <p>Sorry, the requested page does not exist.</p>
     
    </div>
  );
};

export default NotFound;